export const MOVE_BRASIL_FORM_ID = "formulario-move-brasil";

export const MOVE_BRASIL_BANNER = {
	desktop: {
		src: "/images/move-brasil/banner-desktop.png",
		alt: "Move Brasil — Novo Jeep Renegade Longitude MHEV 2027",
	},
	mobile: {
		src: "/images/move-brasil/banner-mobile.png",
		alt: "Move Brasil — Novo Jeep Renegade Longitude MHEV 2027",
	},
} as const;

export const MOVE_BRASIL_IMAGES = {
	carIntro: "/images/move-brasil/renegade-intro.png",
	carApp: "/images/move-brasil/renegade-app.png",
	carTaxi: "/images/move-brasil/renegade-taxi.png",
} as const;

export const MOVE_BRASIL_SYONET_PAGE = "MOVE-BRASIL";
export const MOVE_BRASIL_SYONET_EVENT_TYPE = "VENDA DIRETA WEB";
export const MOVE_BRASIL_PRIVACY_URL =
	"https://www.vitoriamotorsjeep.com.br/politica-de-privacidade";

export const MOVE_BRASIL_MODELS = [
	"Jeep Compass",
	"Jeep Renegade",
] as const;

export const MOVE_BRASIL_UNITS = [
	{ id: 8, nome: "JEEP AV. VITORIA" },
	{ id: 2, nome: "JEEP CACHOEIRO" },
	{ id: 75, nome: "JEEP COLATINA" },
	{ id: 9, nome: "JEEP GUARAPARI" },
	{ id: 3, nome: "JEEP JUIZ DE FORA" },
	{ id: 1, nome: "JEEP LEITÃO DA SILVA" },
	{ id: 4, nome: "JEEP LINHARES" },
	{ id: 5, nome: "JEEP NOVA FRIGURGO" },
	{ id: 10, nome: "JEEP PETRÓPOLIS" },
	{ id: 6, nome: "JEEP SERRA" },
	{ id: 11, nome: "JEEP SÃO MATEUS" },
	{ id: 7, nome: "JEEP VILA VELHA" },
] as const;

export const MOVE_BRASIL_CONDITIONS = [
	{
		icon: "/images/move-brasil/icon-juros.png",
		title: "Juros reduzidos",
		description:
			"Taxas especiais via BNDES: até 0,91% a.m. para mulheres e 0,99% a.m. para homens.",
	},
	{
		icon: "/images/move-brasil/icon-entrada.png",
		title: "Sem entrada mínima",
		description:
			"Financiamento de até 100% do valor do veículo. Carência de 6 meses e prazo de até 72x.",
	},
	{
		icon: "/images/move-brasil/icon-frota.png",
		title: "Frota sustentável",
		description:
			"Veículos zero km flex, híbridos ou elétricos até R$ 150 mil. IOF isento.",
	},
	{
		icon: "/images/move-brasil/icon-renovacao.png",
		title: "Renovação de frota",
		description:
			"Fundo de R$ 30 bilhões do Governo Federal para motoristas profissionais renovarem o carro.",
	},
] as const;
